var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rows = _props.rows,
          cols = _props.cols,
          horizontal = _props.horizontal;


      var el = {
        table: Table,
        tableBody: TableBody,
        tableHeader: TableHeader,
        tableHeaderColumn: TableHeaderColumn,
        tableRow: TableRow,
        tableRowColumn: TableRowColumn
      };

      var props = {
        table: this.props.tableProps,
        tableBody: this.props.tableBodyProps,
        tableHeader: this.props.tableHeaderProps,
        tableHeaderColumn: this.props.tableHeaderColumnProps,
        tableRow: this.props.tableRowProps,
        tableRowColumn: this.props.tableRowColumnProps
      };

      var selected = {
        row: this.props.selectedRow,
        col: this.props.selectedCol
      };

      /* eslint-disable react/no-array-index-key */

      if (horizontal) return React.createElement(
        el.table,
        props.table,
        React.createElement(
          el.tableBody,
          props.tableBody,
          rows.map(function (row, i) {
            return cols.map(function (col, j) {
              return React.createElement(
                el.tableRow,
                Object.assign({ key: 'row-' + i + '-col-' + j }, props.tableRow),
                React.createElement(
                  el.tableHeaderColumn,
                  props.tableHeaderColumn,
                  col.label || col.prop
                ),
                React.createElement(
                  el.tableRowColumn,
                  props.tableRowColumn,
                  selected.row === i && selected.col === j && col.editor ? col.editor(rows[i][col.prop], i, j) : col.render ? col.render(rows[i][col.prop], i, j) : rows[i][col.prop]
                )
              );
            });
          })
        )
      );

      return React.createElement(
        el.table,
        props.table,
        React.createElement(
          el.tableHeader,
          props.tableHeader,
          React.createElement(
            el.tableRow,
            props.tableRow,
            cols.map(function (col, i) {
              return React.createElement(
                el.tableHeaderColumn,
                Object.assign({
                  key: 'col-' + i
                }, props.tableHeaderColumn),
                col.label || col.prop
              );
            })
          )
        ),
        React.createElement(
          el.tableBody,
          props.tableBody,
          rows.map(function (row, i) {
            return React.createElement(
              el.tableRow,
              Object.assign({ key: 'row-' + i }, props.tableRow),
              cols.map(function (col, j) {
                return React.createElement(
                  el.tableRowColumn,
                  Object.assign({
                    key: 'row-' + i + '-col-' + j
                  }, props.tableRowColumn),
                  selected.row === i && selected.col === j && col.editor ? col.editor(row[col.prop], i, j) : col.render ? col.render(row[col.prop], i, j) : row[col.prop]
                );
              })
            );
          })
        )
      );
    }
  }]);

  return _class;
}(Component);

_class.defaultProps = {
  tableProps: {},
  tableBodyProps: {},
  tableHeaderProps: {},
  tableHeaderColumnProps: {},
  tableRowProps: {},
  tableRowColumnProps: {},
  horizontal: false,
  selectedRow: -1,
  selectedCol: -1
};
export default _class;




//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dt/lib/index.js
// module id = 497
// module chunks = 0